import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ToasterService } from 'angular5-toaster/dist';
import { IncludeSurveyModel, SummaryFilterModel } from '../../../../models/summary/summary.model';
import { WordCloudResponseModel } from '../../../../models/survey/survey.model';
import { SurveyService } from '../../../../routes/surveys/surveys.service';

@Component({
  selector: 'app-word-count-table',
  templateUrl: './word-count-table.component.html',
  styleUrls: ['./word-count-table.component.less']
})
export class WordCountTableComponent implements OnInit {
  @Input() surveyId: number;
  @Input() summaryFilterModel: SummaryFilterModel;
  @Input() questionId: number;
  @Input() isSubgroup = false;
  @Input() limit: number;

  dataWordCount: WordCloudResponseModel[];
  dataWordCountDisplay: WordCloudResponseModel[];
  @Input() dataSource: WordCloudResponseModel[];
  @Input() versionName: string;
  dataCloudWordString = '';
  notFoundData = false;
  show = false;
  showClipboard = false;
  enableCopyBtn = false;
  isMouseDown = false;
  showLoader = false;
  constructor(private cdRef: ChangeDetectorRef, private toasterService: ToasterService, private surveyService: SurveyService) { }

  ngOnInit() {
    if (this.isSubgroup) {
      if (this.dataSource.length > 0) {
        this.showLoader = true;
        const self = this;
        self.dataWordCountDisplay = this.dataSource.slice(0, this.limit);
        self.dataCloudWordString = self.dataSource.map(data => data.answerName ).join(', ');
        } else {
          this.notFoundData = true;
          this.cdRef.detectChanges();
        }
        this.showLoader = false;
    } else {
      this.loadResponseTextByQuestion();
    }
  }
  showAll() {
    const self = this;
    self.show = !self.show;
    if (self.show) {
      self.dataWordCountDisplay = this.dataSource;
    } else {
      self.dataWordCountDisplay = this.dataSource.slice(0, self.limit);
    }

  }
  truncateText(text: string) {
    if(text.length > 46) {
      return text.substring(0, 44) + '...';
    }
    return text;
  }
  copyMessage() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.dataCloudWordString;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toasterService.pop('success', 'Copy successful');

  }
  showRawText() {
    this.showClipboard = true;
    this.enableCopyBtn = false;
  }

  closeRawTextModal() {
    this.showClipboard = false;
  }

  showChange(event) {
    this.showClipboard = event;
  }
  
  loadResponseTextByQuestion() {
    this.showLoader = true;
    let versionHash;
    let cutId = null;
    const version = this.summaryFilterModel.includeSurvey.listSurveyVersion.find(version=>version.surveyName === this.versionName);
    const includesrvy = this.summaryFilterModel.includeSurvey;
    const listQstnFilter = this.summaryFilterModel.listQuestionFilter;
    const summaryFilter = JSON.parse(JSON.stringify(this.summaryFilterModel));
    summaryFilter.includeSurvey.listSurveyVersion = includesrvy && includesrvy.listSurveyVersion? includesrvy.listSurveyVersion : [];
    summaryFilter.includeSurvey.listSurveyCut = includesrvy && includesrvy.listSurveyCut ? includesrvy.listSurveyCut : [];
    summaryFilter.listQuestionFilter = listQstnFilter;
    if (version) {
      versionHash = version.hash;
      summaryFilter.includeSurvey.listSurveyVersion = summaryFilter.includeSurvey.listSurveyVersion.filter(survey => survey.hash === version.hash);
      summaryFilter.includeSurvey.listSurveyCut = [];
    } else if(includesrvy.listSurveyCut && includesrvy.listSurveyCut.find(cut=>cut.title === this.versionName)) {
      cutId = includesrvy.listSurveyCut.find(cut=>cut.title === this.versionName).id;
      summaryFilter.includeSurvey.listSurveyVersion = [];
    }
    versionHash = versionHash ? versionHash : '';
    cutId = cutId ? cutId : '';
    this.surveyService.getResponseTextByQuestion(this.surveyId, this.questionId, summaryFilter, versionHash, cutId).subscribe(res => {
      this.dataSource = res;
      if (this.dataSource.length > 0) {
        const self = this;
        this.limit = this.dataSource[0].limit;
        self.dataWordCountDisplay = this.dataSource.slice(0, this.dataSource[0].limit);
        self.dataCloudWordString = self.dataSource.map(data => data.answerName ).join(', ');
      } else {
        this.notFoundData = true;
        this.cdRef.detectChanges();
      }
      this.showLoader = false;
    }, _ => {
      this.showLoader = false;
    });
  
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/word-count-table/word-count-table.component.ts